<template>
  <!--  产品中心 -->
  <div class="">
    <HeaderTop />
    <MenuPage />
    <BannerDetail
      :backgroundImage="require('../assets/img/banner3.jpg')"
      :title="$t('productssub2')"
      :description="$t('hardware2')"
    />

    <div class="product-main">
      <div class="product-box">
        <HardwarePage />
      </div>
    </div>
    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import HardwarePage from "@/components/hardwarePage.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail, HardwarePage },
  name: "NewsPage",
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped>
.product-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding-bottom: 50px;
}

.product-box {
  width: 1200px;
  margin: 0 auto;
}
@media (max-width: 1200px) {
  .product-box {
    width: 100%;
  }
}
</style>
